import { render, staticRenderFns } from "./Sells.vue?vue&type=template&id=2587ab0d&scoped=true&"
import script from "./Sells.vue?vue&type=script&lang=ts&"
export * from "./Sells.vue?vue&type=script&lang=ts&"
import style0 from "./Sells.vue?vue&type=style&index=0&id=2587ab0d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2587ab0d",
  null
  
)

export default component.exports